import { useApp } from '../../state/AppContext';
import Icon from '../../lib/Icon';
import { kv } from '../../lib/format';
import { cardPad } from '../../lib/ui';

export default function ContractDetail() {
  const { go, L } = useApp();

  const cdKpis = [
    { label: L('Contract Value', 'มูลค่าสัญญา'), value: '$4.62M' },
    { label: L('Days Remaining', 'วันคงเหลือ'), value: '361' },
    { label: L('Linked POs', 'ใบสั่งซื้อที่เชื่อมโยง'), value: '2' },
    { label: L('Renewals', 'การต่ออายุ'), value: L('Manual', 'ด้วยตนเอง') },
  ];
  const cdDetails = [
    kv(L('Contract ID', 'รหัสสัญญา'), 'CON-2026-0014', 'var(--font-mono)'),
    kv(L('Supplier', 'ซัพพลายเออร์'), 'Apex Insurance Co.', 'var(--font-sans)'),
    kv(L('Value', 'มูลค่า'), '$4,620,000', 'var(--font-mono)'),
    kv(L('Start Date', 'วันเริ่มต้น'), '2026-07-01', 'var(--font-mono)'),
    kv(L('End Date', 'วันสิ้นสุด'), '2027-06-30', 'var(--font-mono)'),
    kv(L('Signed by', 'ลงนามโดย'), 'Walter Adams (Director)', 'var(--font-sans)'),
  ];
  const cdLifecycle = [
    { icon: 'file-signature', color: 'var(--color-success)', label: L('Signed', 'ลงนามแล้ว') },
    { icon: 'shield-check', color: 'var(--color-success)', label: L('Active', 'ใช้งาน') },
    { icon: 'refresh-cw', color: 'var(--color-fg-3)', label: L('Renewal', 'การต่ออายุ') },
    { icon: 'archive', color: 'var(--color-fg-3)', label: L('Closed', 'ปิดแล้ว') },
  ];

  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 16, marginBottom: 16 }}>
        {cdKpis.map((k) => (
          <div key={k.label} style={cardPad('16px 18px')}>
            <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)', marginBottom: 6 }}>{k.label}</div>
            <div style={{ fontSize: 20, fontWeight: 700, fontFamily: 'var(--font-mono)' }}>{k.value}</div>
          </div>
        ))}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, alignItems: 'start' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div style={cardPad(20)}>
            <div style={{ fontWeight: 700, marginBottom: 14 }}>{L('Term Progress', 'ความคืบหน้าของสัญญา')}</div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: 'var(--color-fg-3)', marginBottom: 6 }}>
              <span>2026-07-01</span>
              <span>2027-06-30</span>
            </div>
            <div style={{ height: 12, borderRadius: 999, background: 'var(--color-ink-50)', overflow: 'hidden' }}>
              <div style={{ height: '100%', width: '1%', background: 'var(--color-success)' }} />
            </div>
            <div style={{ fontSize: 12, color: 'var(--color-fg-3)', marginTop: 8 }}>{L('1% of term elapsed · 362 days remaining', 'ผ่านไป 1% ของระยะเวลา · เหลืออีก 362 วัน')}</div>
          </div>
          <div style={cardPad(20)}>
            <div style={{ fontWeight: 700, marginBottom: 14 }}>{L('Contract Details', 'รายละเอียดสัญญา')}</div>
            {cdDetails.map((d) => (
              <div key={d.k} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--color-border)', fontSize: 13 }}>
                <span style={{ color: 'var(--color-fg-3)' }}>{d.k}</span>
                <span style={{ fontWeight: 600, fontFamily: d.font }}>{d.v}</span>
              </div>
            ))}
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div style={cardPad(20)}>
            <div style={{ fontWeight: 700, marginBottom: 10 }}>{L('Originating Purchase Order', 'ใบสั่งซื้อต้นทาง')}</div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span style={{ fontFamily: 'var(--font-mono)', fontWeight: 600 }}>PO-2026-0041</span>
              <button onClick={() => go('podetail')} style={{ fontSize: 12, fontWeight: 600, color: 'var(--color-blue)' }}>{L('Open in PO Management →', 'เปิดใน จัดการใบสั่งซื้อ →')}</button>
            </div>
          </div>
          <div style={cardPad(20)}>
            <div style={{ fontWeight: 700, marginBottom: 14 }}>{L('Lifecycle', 'วงจรชีวิต')}</div>
            {cdLifecycle.map((s) => (
              <div key={s.label} style={{ display: 'flex', alignItems: 'center', gap: 11, padding: '7px 0' }}>
                <Icon name={s.icon} style={{ color: s.color, fontSize: 18 }} />
                <span style={{ fontSize: 13, fontWeight: 500, color: s.color }}>{s.label}</span>
              </div>
            ))}
          </div>
          <button className="hv-primary" style={{ alignSelf: 'flex-start', padding: '11px 20px', background: 'var(--color-primary)', color: '#fff', borderRadius: 'var(--radius-md)', fontWeight: 600, fontSize: 14 }}>{L('Initiate Renewal', 'เริ่มการต่ออายุ')}</button>
        </div>
      </div>
    </>
  );
}
